"use strict";
import moment from "moment";
const days_to_pay = function(invoice) {
  if (invoice.quickpay) {
    return invoice.quickpay_days_to_pay;
  }
  return invoice.non_quickpay_days_to_pay;
};
const paymentDueOn = function(invoice) {
  return moment(invoice.source_invoice_date).add(days_to_pay(invoice), "days").format("YYYY-MM-DD");
};
export default { paymentDueOn };
